import { AxiosResponse } from 'axios'
import { DataService } from '../../utils/dataService'

export const GET_COUNTRIES = 'GET_COUNTRIES'


export const handleGetCountries = (path: string) => (dispatch: any) => {
  const _dataService = new DataService()

  
  const data = {
    //url: window.location.href,
    url: path,
    filter:{
      'origin': 'epayco'
    }
  }

  _dataService
    .post('/countries', data)
    .then((res: AxiosResponse) => {
        if (res.status === 200 && res.data.success === true) {
          dispatch({
            type: GET_COUNTRIES,
            payload: {
              countries: res.data.data
            }
          })
        }
      })
}

